<template>
  <div
    class="splash"
    :style="{ 'background-image': `url('/img/${photo.file}')` }"
  >
    <div class="splash-text">
      <h1 class="splash-title">Kevin Chen</h1>
      <h2 class="splash-subtitle">Photography</h2>
      <div class="splash-buttons">
        <a class="button" href="client-showcase">View Work</a>
        <a class="button" href="contact">Contact</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.splash {
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center center;
  color: white;

  &::before {
    content: '';
    width: 100%;
    height: 100vh;
    background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.splash-text {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -10rem;
}

.splash-title {
  display: block;
  font-size: 64px;
  line-height: 1.125;
}

.splash-subtitle {
  display: block;
  font-size: 48px;
}

.button {
  display: inline-block;
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border: 2px solid white;
  border-radius: 8px;
  margin-top: 1rem;
  transition: background-color 0.5s, color 0.5s;
  margin-right: 0.5rem;
  font-family: $secondary-font-family;

  &:hover {
    background-color: white;
    color: $text-color;
  }
}
</style>

<script>
import db from '@/database'

export default {
  name: 'Splash',
  data() {
    return {
      photos: db.getSplashPhotos()
    }
  },
  computed: {
    photo() {
      return this.photos[Math.floor(Math.random() * this.photos.length)]
    }
  }
}
</script>
